var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "homepage-blocks"
    }
  }, [_vm.showInboxBlock ? [_c('v-teleport', {
    attrs: {
      "to": "div#mount-user-inbox-block",
      "disabled": false
    }
  }, [_c('UserInboxBlock')], 1)] : _vm._e(), _vm._v(" "), _vm.showELabNextBlock ? [_c('v-teleport', {
    attrs: {
      "to": "div#mount-elabnext-button",
      "disabled": false
    }
  }, [_c('eLabNextButton')], 1)] : _vm._e(), _vm._v(" "), _c('v-teleport', {
    attrs: {
      "to": "div#mount-report-choice",
      "disabled": false
    }
  }, [_c('ReportChoice')], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }